import { AbstractPmsApiService } from "./abstract.service";
import {CurrencyCode} from "../models/currency-code.model";

/**
 * @class CurrencyCodeService
 * @abstract
 * @extends {AbstractPmsApiService<CurrencyCodeService>}
 */
export class CurrencyCodeService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/currency-codes';
    }

    newModel(attributes) {

        return new CurrencyCode(attributes);
    }

     /**
     * @returns {Promise.<CurrencyCode>}
     */
    get() {
        return this.http
            .get(this.url(), {
                headers: this.authHeaders
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/currency-code.service.js